import { createAction, props } from '@ngrx/store';
import { Category, Product } from '@cigna/vampire-dto';

export const initiateConversation = createAction(
  '[OmniChatLink] Initiate Conversation',
  props<{ product?: Product; category?: Category }>(),
);
